import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'cv-file/render',
    timeout: 7000,
});

export async function renderCv(cvData) {
    return backendEndpoint.post('', cvData);
}
